<div class="modal-container">
	<div class="modal-close" (click)="close()">
		<button class="close">
			<img src="./assets/images/Cross.svg" alt="" />
		</button>
	</div>
	<div class="modal-header"></div>
	<div class="modal-body">
		<div class="row">
			<div class="col-lg-7">
				<app-gallery
					[data]="data"
					[dots]="true"
					[preview]="false"
					[showTitle]="false"
				></app-gallery>
				<div class="wrapper-dimensions">
					<div class="d-flex" style="gap: 5px">
						<p>
							<strong
								>{{
									lang === 'pt' ? 'Altura' : 'Altura'
								}}:</strong
							>
							{{ data.height }}
						</p>
						<p>
							<strong
								>{{
									lang === 'pt' ? 'Largura' : 'Ancho'
								}}:</strong
							>
							{{ data.width }}
						</p>
					</div>
					<p>
						<strong
							>{{
								lang === 'pt' ? 'Profundidade' : 'Profundidad'
							}}:</strong
						>
						{{ data.depth }}
					</p>
					<p><strong>Peso:</strong> {{ data.weight }}</p>
					<div class="d-flex justify-content-between">
					<div>
						<p style="margin: 0;">
							<strong>Cores disponíveis:</strong> 
						</p>
						<div class="wrapper-colors">
							<div *ngFor="let item of data.color" class="colors">
								<svg *ngIf="item.name === 'Branco'" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 28 28" fill="none">
									<g filter="url(#filter0_i_178_2219)">
										<circle cx="14" cy="14" r="14" transform="matrix(1 0 0 -1 0 27.9999)" fill="#DBDBDB"/>
									</g>
									<defs>
										<filter id="filter0_i_178_2219" x="0" y="0" width="28" height="31.9999" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
											<feFlood flood-opacity="0" result="BackgroundImageFix"/>
											<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
											<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
											<feOffset dy="4"/>
											<feGaussianBlur stdDeviation="2"/>
											<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
											<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
											<feBlend mode="normal" in2="shape" result="effect1_innerShadow_178_2219"/>
										</filter>
									</defs>
								</svg>
								<svg *ngIf="item.name === 'Prata'" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 28 28" fill="none">
									<g filter="url(#filter0_i_178_2219)">
										<circle cx="14" cy="14" r="14" transform="matrix(1 0 0 -1 0 27.9999)" fill="#949799"/>
									</g>
									<defs>
										<filter id="filter0_i_178_2219" x="0" y="0" width="28" height="31.9999" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
											<feFlood flood-opacity="0" result="BackgroundImageFix"/>
											<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
											<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
											<feOffset dy="4"/>
											<feGaussianBlur stdDeviation="2"/>
											<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
											<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
											<feBlend mode="normal" in2="shape" result="effect1_innerShadow_178_2219"/>
										</filter>
									</defs>
								</svg>
								<svg *ngIf="item.name === 'Preto'" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 28 28" fill="none">
									<g filter="url(#filter0_i_178_2219)">
										<circle cx="14" cy="14" r="14" transform="matrix(1 0 0 -1 0 27.9999)" fill="#0A0A0A"/>
									</g>
									<defs>
										<filter id="filter0_i_178_2219" x="0" y="0" width="28" height="31.9999" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
											<feFlood flood-opacity="0" result="BackgroundImageFix"/>
											<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
											<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
											<feOffset dy="4"/>
											<feGaussianBlur stdDeviation="2"/>
											<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
											<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
											<feBlend mode="normal" in2="shape" result="effect1_innerShadow_178_2219"/>
										</filter>
									</defs>
								</svg>
								<svg *ngIf="item.name === 'Vermelho'" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 28 28" fill="none">
									<g filter="url(#filter0_i_178_2219)">
										<circle cx="14" cy="14" r="14" transform="matrix(1 0 0 -1 0 27.9999)" fill="#B1090C"/>
									</g>
									<defs>
										<filter id="filter0_i_178_2219" x="0" y="0" width="28" height="31.9999" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
											<feFlood flood-opacity="0" result="BackgroundImageFix"/>
											<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
											<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
											<feOffset dy="4"/>
											<feGaussianBlur stdDeviation="2"/>
											<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
											<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
											<feBlend mode="normal" in2="shape" result="effect1_innerShadow_178_2219"/>
										</filter>
									</defs>
								</svg>
							</div>
						</div>
					</div>
				</div>
				</div>
			</div>
			<div class="col">
				<div class="wrapper-header">
					<div class="title w-100">
						<h4>{{ data.name }}</h4>
						<div *ngIf="!hasB2b">
							<p *ngIf="data.price && lang === 'pt'">
								A partir de R$ {{ getPrice(data.price) }}
							</p>
						</div>
						<div *ngIf="hasB2b">
							<p>
								Preço sob consulta
							</p>
						</div>
					</div>
					<div class="w-50" *ngIf="data.line !== 'PLUS' && !hasB2b">
						<app-mybutton
							*ngIf="data.buy_now"
							typeBtn="purchase"
							[ga]="data.buy_now"
							text="compre agora"
							[href]="data.buy_now"
						>
						</app-mybutton>
					</div>
				</div>
				<div class="wrapper">
					<div class="wrapper-items">
						<img
							[src]="data.temperature_icon.url"
							[alt]="data.temperature"
						/>
						<span>{{ data.temperature }}</span>
					</div>
					<div class="wrapper-items">
						<img
							[src]="data.server_until_icon.url"
							alt="Depósito"
						/>
						<span>{{ data.serves_until }}</span>
					</div>
					<div class="wrapper-items">
						<img
							[src]="data.capacity_icon.url"
							[alt]="data.capacity"
						/>
						<span>{{ data.capacity }}</span>
					</div>
					<div class="wrapper-items">
						<img
							[src]="data.compressor_system_icon.url"
							[alt]="data.compressor_system"
						/>
						<span>{{ data.compressor_system }}</span>
					</div>
					<div class="wrapper-items">
						<img
							[src]="data.voltage_icon.url"
							[alt]="dictionary.voltage"
						/>
						<span>{{ data.voltage }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<div *ngIf="!hasB2b">
			<div class="wrapper-items" *ngIf="data.line !== 'PLUS'">
				<div class="item">
					<p class="blue">
						{{
							lang === 'pt'
								? 'Condição de Pagamento'
								: 'Condición de pago'
						}}
					</p>
					<p>
						{{
							lang === 'pt'
								? 'Em até 12x sem juros no cartão'
								: 'Hasta 12 cuotas sin intereses en tu tarjeta'
						}}
					</p>
				</div>
				<div class="item">
					<p class="blue">
						{{ lang === 'pt' ? 'Distribuição' : 'Distribución' }}
					</p>
					<p>
						{{
							lang === 'pt'
								? 'Entrega em todo Brasil'
								: 'Entrega en todo Brasil'
						}}
					</p>
				</div>
				<div *ngIf="data.line !== 'BABY'" class="item">
					<p class="blue">
						{{ lang === 'pt' ? 'Instalação' : 'Instalación' }}
					</p>
					<p>{{ lang === 'pt' ? 'Grátis' : 'Gratis' }}</p>
				</div>
			</div>
			<div
				class="wrapper-items wrapper-items--plus"
				*ngIf="data.line === 'PLUS'"
			>
				<div class="item">
					<p class="blue">
						{{
							lang === 'pt'
								? 'Modelo destinado a estabelecimentos comerciais'
								: 'Modelo destinado a establecimientos comerciales'
						}}
					</p>
					<p>
						{{
							lang === 'pt'
								? 'Encontre a revenda mais próxima'
								: 'Encuentra el revendedor más cercano'
						}}
					</p>
				</div>
				<div class="item">
					<app-mybutton
						typeBtn="purchase"
						[text]="
							lang == 'pt'
								? 'Pesquisar revendas'
								: 'Buscar revendedores'
						"
						href="/pt/onde-encontrar-revenda-everest"
					>
					</app-mybutton>
				</div>
			</div>
		</div>
		<div
			class="wrapper-items wrapper-items--plus"
			*ngIf="hasB2b"
		>
			<div class="item">
				<p class="blue">
					{{
						lang === 'pt'
							? 'Modelo destinado a estabelecimentos comerciais'
							: 'Modelo destinado a establecimientos comerciales'
					}}
				</p>
				<p>
					{{
						lang === 'pt'
							? 'Solicite uma análise para sua empresa'
							: 'Solicite un análisis para su empresa'
					}}
				</p>
			</div>
			<div class="item">
				<app-mybutton
					[text]="
						lang == 'pt'
							? 'Faça uma cotação'
							: 'Solicita un presupuesto'
						"
					(btnClick)="goToB2bForm()"
				>
				</app-mybutton>
			</div>
		</div>
	</div>
</div>
